module.exports = __webpack_public_path__ + "img/quality.83ad050a.svg";